import React, { forwardRef, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { Stack } from '../stack';
import { InputAddon, InputAddonOwnProps } from './InputAddon';
import { CSSValueWithLength } from '../../styles';

export interface InputAffixProps extends Omit<InputAddonOwnProps, 'position'> {
  className?: string;
  width?: CSSValueWithLength;
  /** Input 좌측에 렌더링될 요소 */
  prefix?: string;
  /** Input 우측에 렌더링될 요소 */
  suffix?: string;
}

export const InputAffix = forwardRef<HTMLDivElement, PropsWithChildren<InputAffixProps>>(
  ({ className, children, prefix, suffix, width, disabled, status = 'info', size }, ref) => {
    return (
      <Stack
        direction='row'
        width={width}
        align='center'
        className={classNames('pds-input-affix', className)}
        ref={ref}
      >
        {prefix && (
          <InputAddon status={status} disabled={disabled} size={size} position='left'>
            {prefix}
          </InputAddon>
        )}
        {children}
        {suffix && (
          <InputAddon status={status} disabled={disabled} size={size} position='right'>
            {suffix}
          </InputAddon>
        )}
      </Stack>
    );
  },
);

InputAffix.displayName = 'InputAffix';
